import { render, staticRenderFns } from "./BuycoAppBar.vue?vue&type=template&id=a71aa0be&"
import script from "./BuycoAppBar.vue?vue&type=script&lang=js&"
export * from "./BuycoAppBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports